var ETechnicalDefinitionBadgeType = /*#__PURE__*/ function(ETechnicalDefinitionBadgeType) {
    ETechnicalDefinitionBadgeType["New"] = "NEW";
    ETechnicalDefinitionBadgeType["Modified"] = "MODIFIED";
    return ETechnicalDefinitionBadgeType;
}(ETechnicalDefinitionBadgeType || {});
export { ETechnicalDefinitionBadgeType };
